import { TableCell } from '@/components/ui/table';
import { formatNumber } from '@/utils/format/number';
import type { UnitOverviewRow } from '@/warranty-v3/entities/overview';

type AgeInYearsCellProps = {
  row: UnitOverviewRow;
};

export function AgeInYearsCell({ row }: AgeInYearsCellProps) {
  return (
    <TableCell narrow justify="left">
      {typeof row.ageInYears === 'number' ? formatNumber(row.ageInYears) : '-'}
    </TableCell>
  );
}
